import { blue as muiBlue, yellow } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

const breakpoints = createBreakpoints({});

export const black = '#3e3e3e';
export const blue = '#5B9EF9';
export const blueLight = '#deebfd';
export const green = '#52d1a8';
export const greenLight = '#f1fffa';
export const grey = '#90908d';
export const greyMedium = '#dfdfdf';
export const greyLight = '#ececec';
export const red = '#ff6d4c';
export const purple = '#390d60'; // for private/internal
export const purpleLight = '#390d601a'; // for internal notes, background
export const affirmative = '#16b895';
export const warn = '#FFA726';
export const warnBackground = '#fff7ea';
export const pending = yellow[600];
export const highlighterYellow = '#fefa7c';
export const backgroundDarker = '#f4f3ef';
export const backgroundDefault = '#fbfbfb';
export const backgroundLight = '#fcfbfa';
export const primary = '#001a2a';
export const secondary = '#e57d6c';
export const gold = 'rgb(255, 215, 0)';
export const error = '#ff5838';
export const destructive = '#ff5838';
export const selected = muiBlue[500]; // Selection approved / PO confirmed, etc.
export const needsResponse = '#ff5838';

const headerWeight = 400; // 400 and 500 are currently the same (Medium)

export default createTheme({
  palette: {
    primary: {
      main: '#001a2a',
      contrastText: '#fff',
    },
    secondary: {
      main: '#e57d6c',
      contrastText: '#fff',
    },
    background: {
      darker: backgroundDarker,
      default: backgroundDefault,
      light: backgroundLight,
    },
    black: {
      main: '#3e3e3e',
      contrastText: '#fff',
    },
    affirmative: {
      main: '#16b895',
      translucent: '#16b8951a',
      contrastText: '#fff',
    },
    needsResponse: {
      main: '#ff5838',
      contrastText: '#fff',
    },
    error: {
      main: error,
      contrastText: '#fff',
    },
    warn: {
      main: '#ffd657',
    },
    highlighterYellow: {
      main: '#fefa7c',
    },
    grey: {
      // main: '#b0aba5',
      main: '#85807c',
      light: '#e2ded9',
      // light: '#f2f2f2'
    },
  },
  typography: {
    fontFamily: ['Roobert', 'sans-serif'],
    useNextVariants: true,
    h1: {
      fontSize: 36,
      fontWeight: headerWeight,
      '@media (max-width: 600px)': {
        fontSize: 28,
      },
    },
    h2: {
      fontSize: 24,
      fontWeight: headerWeight,
      '@media (max-width: 600px)': {
        fontSize: 18,
      },
    },
    h3: {
      fontSize: 18,
      fontWeight: headerWeight,
      '@media (max-width: 600px)': {
        fontSize: 14,
      },
    },
    h4: {
      fontSize: 16,
      fontWeight: headerWeight,
      '@media (max-width: 600px)': {
        fontSize: 12,
      },
    },
    h5: {
      fontSize: 14,
      fontWeight: headerWeight,
      '@media (max-width: 600px)': {
        fontSize: 11,
      },
    },
    h6: {
      // CAREFUL IF CHANGING FONT-SIZE -- Dialog Headers rely on this
      fontWeight: headerWeight,
    },
    subtitle1: {
      color: '#90908d',
      fontWeight: 350,
    },
    subtitle2: {
      fontWeight: 350,
    },
    caption: {
      fontSize: '0.9rem',
      color: '#b0aba5',
      fontWeight: 350,
    },
    overline: {
      fontSize: '10px',
      letterSpacing: '0.75px',
      lineHeight: '11px',
      fontWeight: 400,
    },
  },
  overrides: {
    MuiAppBar: {
      // colorPrimary: {
      //   backgroundColor: '#3e3e3e'
      // }
    },
    MuiAvatar: {
      root: {
        fontSize: '13px',
        width: '30px',
        height: '30px',
      },
      colorDefault: {
        backgroundColor: '#e5e5e5',
        color: black,
      },
    },
    MuiDialog: {
      paper: {
        background: '#FCFBFA',
        padding: '16px',
        borderRadius: 8,
        [breakpoints.down('md')]: {
          padding: '12px 8px',
        },
      },
    },
    MuiDialogTitle: {
      root: {
        fontSize: '24px',
        fontWeight: headerWeight,
      },
    },
    MuiDialogContent: {
      root: {
        // padding: '16px 8px'
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: backgroundDarker,
      },
    },
    MuiButton: {
      // Name of the component ⚛️ / style sheet
      root: {
        textTransform: 'none',
        minWidth: '52px',
        borderRadius: 2,
      },
      label: {
        letterSpacing: '1px',
        fontWeight: 400,
      },
    },
    MuiIconButton: {
      root: {
        padding: 10,
      },
    },
    MuiChip: {
      root: {
        margin: '3px',
      },
    },
    MuiInputLabel: {
      root: {
        color: '#262626',
      },
    },
    MuiPaper: {
      root: {
        color: 'inherit',
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        fontSize: '1rem',
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: '0.8rem',
        borderRadius: 0,
      },
    },
    MuiTableCell: {
      head: {
        fontWeight: 600,
      },
    },
    MuiMenuItem: {
      root: {
        paddingTop: 8,
        paddingBottom: 8,
      },
    },
  },
});

export const mixins = {
  spread: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  kebab: {
    display: 'flex',
    alignItems: 'center',
  },
  centered: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ellipsis: {
    whiterSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
};
